module.exports = __webpack_public_path__ + "img/part02.7c64c553.png";